import React from "react";

import { IconWarningCircle } from "~/components/icon";
import { cx } from "~/tools/class-variance";
import { isNumber } from "~/tools/is-number";

import { type ChartSize, getChartSize } from "../_utils";

import noData from "./no-data.svg";

export interface EmptyChartProps {
	size?: number | ChartSize;
	className?: string;
}

export const EmptyChart = React.forwardRef<React.ComponentRef<"div">, EmptyChartProps>(({ size, className }, ref) => (
	<div
		className={cx("mx-auto my-0 flex size-full flex-col items-center justify-center bg-left bg-repeat-x", className)}
		data-testid="empty-chart"
		ref={ref}
		style={{
			backgroundImage: `url(${noData})`,
			minHeight: isNumber(size) ? size : getChartSize(size),
		}}
	>
		<div className="flex flex-wrap items-center">
			<IconWarningCircle className="mr-2.5 text-orange-500" />
			No data
		</div>
	</div>
));
